//#region imports
import { useDispatch, useSelector } from "react-redux";
//#endregion

//#region functions
import { downloadPdfFile } from "../../Helper/FileHelper";
import { getTranslations } from "../../Helper/TranslationController";
//#endregion

//#region constants
import { FOLDER_TRANSLATION_KEY } from "../../Constants/Documentation";
import { ICON_PDF } from "../../Constants/IconConstants";
import { TRANSLATIONS } from "../../Constants/Translations";
import { autoSortDocumentationLinks, getLogValue } from "./Documentation.constants";
//#endregion

//#region style import
import "./Documentation.style.scss";
//#endregion

const Documentation = ({ title, links, machineName }) => {
  //#region hook
  const translations = useSelector((state) => state.translationSlice.translations);
  const machines = useSelector((state) => state.machineSlice.machines);
  const activeCenterId = useSelector((state) => state.connexionSlice.trainer?.activeCenter.id);
  //#endregion

  //#region others use...
  const dispatch = useDispatch();
  //#endregion

  //#region functions
  const renderLinks = () => {
    const sortedLinks = autoSortDocumentationLinks(links);
    return (
      <ul className="documentation-links-list">
        {sortedLinks.map((link) => {
          return (
            <li
              key={link?.filePath}
              className="documentation-links-list-item"
              onClick={() =>
                downloadPdfFile(
                  `${process.env.PUBLIC_URL}/${link?.filePath}`,
                  null,
                  getTranslations(link?.translationKey, translations),
                  getTranslations(TRANSLATIONS.NOTIFICATION_FILE_DOWNLOADED, translations),
                  dispatch,
                  getLogValue(link?.translationKey, machines),
                  activeCenterId
                )
              }
            >
              <i className={ICON_PDF} />
              <span className="documentation-links-list-item-text">
                {getTranslations(link?.translationKey, translations)}
              </span>
            </li>
          );
        })}
      </ul>
    );
  };
  //#endregion

  return (
    <>
      <span className="documentation-links-title">
        <b>{getTranslations(FOLDER_TRANSLATION_KEY[title], translations)}</b>{" "}
        <i>{machineName && `(${getTranslations(machineName + "_name", translations)})`}</i>
      </span>
      {renderLinks()}
    </>
  );
};

export default Documentation;
